const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const resolveEventToLensDelta = (event, lens, integrationCapacity, pressure) => {
  const { B, S, N, I } = lens;

  // Magnitude Scaling
  const effectiveMagnitude = event.magnitude * clamp(integrationCapacity, 0, 1);

  // Integration Cost
  const integrationCost = event.magnitude * (1 + pressure);

  // Lens Delta Calculation
  const lensDelta = {};

  const createDelta = (currentValue, change) => Math.max(0, Math.min(1, currentValue + change));

  switch (event.axis) {
    case 'B':
      lensDelta.B = createDelta(B, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude);
      break;
    case 'S':
      lensDelta.S = createDelta(S, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude);
      break;
    case 'N':
      lensDelta.N = createDelta(N, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude);
      break;
    case 'I.openness':
      lensDelta.I = { ...I, openness: createDelta(I.openness, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude) };
      break;
    case 'I.fear':
      lensDelta.I = { ...I, fear: createDelta(I.fear, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude) };
      break;
    case 'I.care':
      lensDelta.I = { ...I, care: createDelta(I.care, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude) };
      break;
    case 'I.control':
      lensDelta.I = { ...I, control: createDelta(I.control, event.affordanceType === 'expand' ? effectiveMagnitude : -effectiveMagnitude) };
      break;
    default:
      break;
  }

  // Residue Delta
  let residueDelta = 0;
  if (integrationCost > integrationCapacity) {
    residueDelta = integrationCost - integrationCapacity;
  }

  return {
    lensDelta,
    residueDelta,
    integrationCost,
  };
};
